import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

export default function MultiSelectAutocomplete({ options, label, value, onChange, required, disabled}) {
    return (
        <Autocomplete
            multiple
            id="tags-outlined"
            options={options}
            getOptionLabel={(option) => option.value}
            value={value}
            onChange={(event, newValue) => onChange(event, newValue)}
            isOptionEqualToValue={(option, selectedValue) => option.value === selectedValue.value}
            disabled={disabled}
            renderInput={(params) => (
                <TextField
                    {...params}
                    required={required}
                    variant="outlined"
                    label={label}
                    placeholder={`Selecione`}
                    disabled={disabled}
                />
            )}
        />
    );
}
